import { config } from '@/config';

/** Brand mark and name; the name is configuration (VITE_BRAND_NAME). */
export function Brand() {
  return (
    <span className="flex items-center gap-2.5">
      <span
        aria-hidden="true"
        className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-soft font-display text-lg text-accent-strong"
      >
        {config.brandName.charAt(0)}
      </span>
      <span className="font-display text-xl text-ink">{config.brandName}</span>
    </span>
  );
}
